export default __webpack_public_path__ + "a479d2d8245368fc85b5f56c6cef6e1c.webp";